import { Box, Grid, IconButton } from '@mui/material';

import { FHButton } from '../../../../../../base';
import { FORTA_BLUE } from '../../../../../../../utils/colors';
import TrashIcon from '../../../../../../svgs/TrashIcon3';
import DownloadIcon from '../../../../../../svgs/DownloadButton';

interface SupervisionActionsProps {
  isSupervisionCompleted: boolean;
  showDeleteButton: boolean;
  showEditButton: boolean;
  isStartDisabled: boolean;
  onStart: () => void;
  onOpenDeleteDialog: () => void;
  onOpenDownloadDialog: () => void;
  onOpenEditDialog: () => void;
}

function SupervisionActions({
  isSupervisionCompleted,
  showDeleteButton,
  showEditButton,
  isStartDisabled,
  onStart,
  onOpenDeleteDialog,
  onOpenDownloadDialog,
  onOpenEditDialog,
}: SupervisionActionsProps) {
  return (
    <Grid item xs={8} md={1.3} sm={3} mb={1}>
      {isSupervisionCompleted ? (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
          {showEditButton && (
            <FHButton sx={{ mr: 1 }} data-testid="editParentSN" onClick={onOpenEditDialog}>
              Edit
            </FHButton>
          )}
          <IconButton data-testid="downloadPDF" onClick={onOpenDownloadDialog}>
            <DownloadIcon color={FORTA_BLUE.primary} width={24} height={24} />
          </IconButton>
        </Box>
      ) : (
        <FHButton
          data-testid="startParentSuperVisionNotesButton"
          sx={{ mt: 4 }}
          disabled={isStartDisabled}
          onClick={onStart}
        >
          Start
        </FHButton>
      )}
      {showDeleteButton && (
        <IconButton
          sx={{
            mt: 4,
            opacity: 0.5,
            '&:hover': {
              opacity: 1,
            },
          }}
          data-testid="deleteParentSN"
          onClick={onOpenDeleteDialog}
        >
          <TrashIcon color={FORTA_BLUE.primary} width={24} height={24} />
        </IconButton>
      )}
    </Grid>
  );
}

export default SupervisionActions;
